import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { systemHealthApi } from '../../api/systemHealth';

/** Manager+ only — polls every 15s to match YARP's own active health-check interval, so the
 * page never shows staler data than the gateway itself has. */
export function useServiceRegistry() {
  return useQuery({
    queryKey: ['system-health', 'registry'],
    queryFn: () => systemHealthApi.registry(),
    refetchInterval: 15_000,
  });
}

/** Admin only — OrderService's DLQ backlog. */
export function useOrderDlq(status?: string) {
  return useQuery({
    queryKey: ['system-health', 'order-dlq', status ?? 'all'],
    queryFn: () => systemHealthApi.orderDlq(status),
    refetchInterval: 30_000,
  });
}

export function useRetryOrderDlqEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => systemHealthApi.retryOrderDlqEvent(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['system-health', 'order-dlq'] }),
  });
}

export function useDiscardOrderDlqEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => systemHealthApi.discardOrderDlqEvent(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['system-health', 'order-dlq'] }),
  });
}
